import {
  DocumentProperties,
  DocumentUploadUrl,
  DocumentUploadUrlResponse,
  EmailDocumentCommand,
  RelatedDocument,
  SignedDocument,
} from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'order';

export class OrderDocumentController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async getDocumentsByOrderId(orderId: number): Promise<SignedDocument[]> {
    const response = await this.http.get<SignedDocument[]>(
      `${orderId}/document`,
    );
    return response.data.map((val) => new SignedDocument(val));
  }

  async getRelatedDocumentsByOrderId(
    orderId: number,
  ): Promise<RelatedDocument[]> {
    const response = await this.http.get<RelatedDocument[]>(
      `${orderId}/document/related`,
    );
    return response.data.map((val) => new RelatedDocument(val));
  }

  async getUploadUrl(
    orderId: number,
    documentUploadUrl: DocumentUploadUrl,
  ): Promise<DocumentUploadUrlResponse> {
    const response = await this.http.post<DocumentUploadUrlResponse>(
      `${orderId}/document/upload-url`,
      documentUploadUrl,
    );
    return new DocumentUploadUrlResponse(response.data);
  }

  async attachDocument(
    orderId: number,
    documentProperties: DocumentProperties,
  ): Promise<SignedDocument> {
    const response = await this.http.post<SignedDocument>(
      `${orderId}/document`,
      documentProperties,
    );
    return new SignedDocument(response.data);
  }

  async emailDocuments(
    orderId: number,
    emailDocumentCommand: EmailDocumentCommand,
  ): Promise<void> {
    await this.http.post<void>(
      `${orderId}/document/email-documents`,
      emailDocumentCommand,
    );
  }

  async updateDocument(
    orderId: number,
    documentId: number,
    documentProperties: DocumentProperties,
  ): Promise<SignedDocument> {
    const response = await this.http.put<SignedDocument>(
      `${orderId}/document/${documentId}`,
      documentProperties,
    );
    return new SignedDocument(response.data);
  }

  async removeDocument(orderId: number, documentId: number): Promise<void> {
    await this.http.delete<void>(`${orderId}/document/${documentId}`);
  }
}
